import React from 'react';
import { Aircraft, BookingLeg, Passenger } from 'acscp/store';
import { FormattedMessage } from 'react-intl';
import style from './aircraftDetails.module.scss';
import { LabeledItem } from 'acscp/components/common/labeledItem';
import classNames from 'classnames';
import { withCollapsable } from 'acscp/components/common/collapsable';
import { Title } from 'acscp/components/itinerary/collapsableSections';

interface AircraftDetailsProps {
    aircraft: Aircraft;
    isLongStandingCustomer: boolean;
    legs?: BookingLeg[];
    passengers?: Passenger[];
    flightNumber?: string;
}

const AircraftDetailsContent: React.SFC<AircraftDetailsProps> = ({aircraft, legs, passengers, flightNumber, isLongStandingCustomer}) => {
    const numberOfPassengers = legs && legs[0].numberOfPassengers;
    return (
        <div className={style.Container}>
            <div className={style.InnerContainer}>
                <div className={classNames(style.AircraftDetail, style.AircraftTypeContainer)}>
                    <div className={style.AircraftTypeLabel}>
                        <FormattedMessage
                            id={'web.components.itinerary.aircraft.aircraft'}
                            defaultMessage={'Aircraft'}
                        />
                    </div>
                    <div className={style.AircraftType}>{aircraft.type}</div>
                </div>
                <div className={style.AircraftDetail}>
                    <LabeledItem
                        label={
                            <FormattedMessage
                                id={'web.components.itinerary.aircraft.registration'}
                                defaultMessage={'Reg / Tail No.'}
                            />}
                        linebreak={true}
                    >
                        {aircraft.registration}
                    </LabeledItem>
                </div>
                {numberOfPassengers &&
                    <div className={classNames(style.AircraftDetail, style.PassengersContainer)}>
                        <LabeledItem
                            label={
                                <FormattedMessage
                                    id={'web.components.itinerary.aircraft.passengersLabel'}
                                    defaultMessage={'Passengers Expected'}
                                />}
                            linebreak={true}
                        >
                            {numberOfPassengers ?
                                (
                                    <FormattedMessage
                                        id={'web.components.itinerary.aircraft.passengers'}
                                        defaultMessage={'{passengers} passengers'}
                                        values={{ passengers: numberOfPassengers }}
                                    />
                                )
                                : null}
                        </LabeledItem>
                    </div>
                }
                {passengers &&
                    <div className={style.AircraftDetail}>
                        <LabeledItem
                            label={
                                <FormattedMessage
                                    id={'web.components.itinerary.aircraft.leadPassenger'}
                                    defaultMessage={'Lead Passenger'}
                                />}
                            linebreak={true}
                        >
                            {passengers.length > 0 ? passengers[0].name : null}
                        </LabeledItem>
                    </div>
                }
                {flightNumber &&
                    <div className={style.AircraftDetail}>
                        {isLongStandingCustomer ? (
                            <LabeledItem
                                label={
                                    <FormattedMessage
                                        id={'web.components.itinerary.aircraft.enquiryNumber'}
                                        defaultMessage={'Enquiry Number'}
                                    />}
                                linebreak={true}
                            >
                                {flightNumber}
                            </LabeledItem>
                            ) : (
                                <LabeledItem
                                    label={
                                        <FormattedMessage
                                            id={'web.components.itinerary.aircraft.flightNumber'}
                                            defaultMessage={'Flight Number'}
                                        />}
                                    linebreak={true}
                                >
                                    {flightNumber}
                                </LabeledItem>
                            )
                        }
                    </div>
                }
            </div>
        </div>
    );
};

const AircraftDetails = withCollapsable(
    <Title><FormattedMessage id={'web.components.itinerary.aircraftTitle'} defaultMessage={'AIRCRAFT'} /></Title>,
    AircraftDetailsContent);

export { AircraftDetails };
